import React, { useCallback, useEffect, useMemo, useState } from "react";
import { callApiAction } from "../../store/actions/commonAction";
import { useDispatch } from "react-redux";
import { closeModal } from "../../store/actions/modalAction";
import { getDeviceByIdApi, updateDeviceQcApi } from "../../apis/deviceQc.api";
import { callSnackBar } from "../../store/actions/snackbarAction";
import { SNACK_BAR_VARIETNS } from "../../utils/constants";
import useValidate from "../../store/hooks/useValidator";
import {
  Box,
  Checkbox,
  CircularProgress,
  Divider,
  FormControlLabel,
  InputAdornment,
  Typography,
} from "@mui/material";
import { toTitleSpaceCase } from "../../utils/main";
import { CenteredBox } from "../../components/layouts/OneViewBox";
import CustomDialog from "../../components/layouts/common/CustomDialog";
import BarcodeIcon from "@mui/icons-material/QrCode2";
import CustomInput from "../../components/inputs/CustomInputs";

const BoxContainsEdit = ({ id }) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const validate = useValidate();

  const [fields, setFields] = useState({
    err: "",
    box_Contains: [
      { cable: false },
      { doms: false },
      { manual: false },
      { charging_Case: false },
      { charging_Adepter: false },
      { cleaning_Brush: false },
      { warranty_Card: false },
    ],
    boxId: null,
  });

  const validationSchemaForCreate = useMemo(
    () => [
      {
        // required: true,
        value:
          fields.box_Contains.length !== 0 &&
          fields.box_Contains.some((item) => Object.values(item)[0]),
        field: "Box Contains",
      },
      {
        required: true,
        value: fields.boxId,
        field: "Box ID",
      },
    ],
    [fields],
  );

  const updateFunction = async (e) => {
    e.preventDefault();
    const validationResponse = validate(validationSchemaForCreate);

    if (validationResponse === true) {
      setLoading(true);
      dispatch(
        callApiAction(
          async () =>
            await updateDeviceQcApi({
              id,
              box_Contains: fields.box_Contains,
              boxId: fields.boxId,
            }),
          async (response) => {
            setLoading(false);
            dispatch(
              callSnackBar(
                "Packaging Details Updated Successfully",
                SNACK_BAR_VARIETNS.suceess,
              ),
            );
            dispatch(closeModal("update-product-qc"));
          },
          (err) => {
            setLoading(false);
            setFields({ ...fields, err });
          },
        ),
      );
    } else {
      setFields({ ...fields, err: validationResponse });
    }
  };

  const fetchById = useCallback(
    (id) => {
      setLoading(true);
      dispatch(
        callApiAction(
          async () => await getDeviceByIdApi({ id }),
          async (response) => {
            setFields((prev) => ({
              ...prev,
              ...response,
              box_Contains: prev.box_Contains.map((item) => {
                const key = Object.keys(item)[0];

                const apiItem = response.box_Contains?.find(
                  (resItem) => Object.keys(resItem)[0] === key,
                );

                return apiItem ? apiItem : item;
              }),
            }));
            setLoading(false);
          },
          (err) => {
            setFields((prev) => ({ ...prev, err }));
            setLoading(false);
          },
        ),
      );
    },
    [dispatch],
  );

  useEffect(() => {
    if (id) fetchById(id);
  }, [id, fetchById]);

  const toggleContains = useCallback((targetKey) => {
    setFields((prev) => ({
      ...prev,
      box_Contains: prev.box_Contains.map((item) => {
        const key = Object.keys(item)[0];

        return key === targetKey ? { [key]: !item[key] } : item;
      }),
    }));
  }, []);

  return (
    <>
      <CustomDialog
        id={"update-product-qc"}
        loading={loading}
        err={fields.err}
        onSubmit={(e) => updateFunction(e)}
        title={"Update Package Details"}
        closeText="Close"
        confirmText={"Update"}
      >
        {loading ? (
          <CenteredBox>
            <CircularProgress />
          </CenteredBox>
        ) : (
          <>
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                gap: 2,
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 600,
                  minWidth: { sm: "150px" },
                }}
              >
                Box Contains
              </Typography>
              <Box sx={{ width: "100%" }}>
                {fields.box_Contains.map((item) => {
                  const key = Object.keys(item)[0];
                  const value = item[key];

                  return (
                    <Box
                      key={key}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        mb: 1,
                      }}
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={value}
                            onChange={() => toggleContains(key)}
                            size="small"
                          />
                        }
                        label={key}
                      />
                    </Box>
                  );
                })}
              </Box>
            </Box>
            <Divider sx={{ mb: 6, mt: 2 }} />
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                gap: 2,
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 600,
                  minWidth: { sm: "150px" },
                }}
              >
                Box Id
              </Typography>
              <Box sx={{ width: "100%" }}>
                <CustomInput
                  autoFocus
                  value={fields.boxId}
                  onChange={(e) =>
                    setFields((prev) => ({
                      ...prev,
                      boxId: e.target.value,
                    }))
                  }
                  type="text"
                  label="Barcode Scanner"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <BarcodeIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>
            </Box>
          </>
        )}
      </CustomDialog>
    </>
  );
};

export default BoxContainsEdit;
